import { render, staticRenderFns } from "./CabeceraDetalleGestion.vue?vue&type=template&id=a9256760"
import script from "./CabeceraDetalleGestion.vue?vue&type=script&lang=js"
export * from "./CabeceraDetalleGestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports